import React from 'react';
import { graphql } from 'gatsby';

import Layout from '../components/layout';
import Article from '../components/article';

export default ({ data: { prismicRankings: node }, location: { pathname } }) => {
    const entries = node.data.entry.map(entry => ({
        entryTitle: entry.title.text,
        entryRank: entry.wyse_rank,
        entryImage: entry.entry_image,
        entryText: entry.ranking_text.html,
    }));

    const articleProps = {
        pathname,
        uid: node.uid,
        image: node.data.title_image,
        title: node.data.title.text.trim(),
        body: node.data.teaser.html,
        bodyText: node.data.teaser.text,
        entries,
        tags: node.tags,
        author: node.data.author,
        date: (new Date(node.last_publication_date)).toLocaleDateString('en-US', {
            day: 'numeric',
            year: 'numeric',
            month: 'short'
        })
    };

    return <Layout pathname={pathname}><Article {...articleProps} forAwards /></Layout>;
};

export const query = graphql`
    query WyseAwardQuery($uid: String!) {
        prismicRankings(uid: { eq: $uid }) {
            uid
            tags
            last_publication_date
            data {
                title {
                    text
                }
                title_image {
                    url
                    dimensions {
                        height
                        width
                    }
                    localFile {
                        childImageSharp {
                            fluid(maxWidth: 976, maxHeight: 400, quality: 100, cropFocus: CENTER) {
                                ...GatsbyImageSharpFluid_withWebp
                            }
                        }
                    }
                }
                teaser {
                    text
                    html
                }
                entry {
                    wyse_rank
                    title {
                    text
                    }
                    ranking_text {
                        html
                    }
                    entry_image {
                    dimensions {
                        width
                        height
                    }
                    url
                        localFile {
                            childImageSharp {
                                fluid(maxWidth: 719, maxHeight: 160, quality: 100, cropFocus: CENTER) {
                                    ...GatsbyImageSharpFluid_withWebp
                                }
                                fixed(width: 300, height: 160, quality: 100, cropFocus: CENTER) {
                                    ...GatsbyImageSharpFixed_withWebp
                                }
                            }
                        }
                    }
                }
                author
            }
        }
    }
`;
